// =================================================================
// Store: Memoized selectors (PSD §9.2 / TODO Task 1.14, CC.2)
// =================================================================
import { useStore } from './useStore';
import { shallow } from 'zustand/shallow';

export const usePatient = () =>
  useStore((s) => ({ patient: s.patient, validationErrors: s.validationErrors }), shallow);

export const useStrategy = () => useStore((s) => s.strategyConfig, shallow);

export const useDosingWeight = () => useStore((s) => s.dosingWeight, shallow);

export const useRenal = () => useStore((s) => s.renal, shallow);

export const useSafety = () => useStore((s) => s.safety, shallow);

export const useRegimen = () => useStore((s) => s.regimen, shallow);

export const useMonitoring = () => useStore((s) => s.monitoring, shallow);

export const useValidationErrors = () => useStore((s) => s.validationErrors, shallow);

export const useSettings = () => useStore((s) => s.settings, shallow);

export const useLevels = () => useStore((s) => ({ levels: s.levels, pkParameters: s.pkParameters }), shallow);

export const useHartfordLevel = () => useStore((s) => s.hartfordLevel, shallow);

export const useAgentParams = () => useStore((s) => s.agentParams, shallow);

export const useDoseRounding = () => useStore((s) => s.doseRoundingEnabled, shallow);

export const useMIC = () =>
  useStore((s) => ({ micValue: s.micValue, micSource: s.micSource }), shallow);

export const usePKParameters = () => useStore((s) => s.pkParameters, shallow);

export const useActions = () =>
  useStore(
    (s) => ({
      setPatientField: s.setPatientField,
      setAgent: s.setAgent,
      setIndication: s.setIndication,
      setStrategy: s.setStrategy,
      setInfusionDuration: s.setInfusionDuration,
      setInfusionStart: s.setInfusionStart,
      setNomogramSource: s.setNomogramSource,
      setPopulationMode: s.setPopulationMode,
      setPKSource: s.setPKSource,
      computeAll: s.computeAll,
      overrideDosingWeight: s.overrideDosingWeight,
      overrideContraindication: s.overrideContraindication,
      applyDoseRounding: s.applyDoseRounding,
      setMIC: s.setMIC,
      overrideRegimen: s.overrideRegimen,
      setHartfordLevel: s.setHartfordLevel,
      addLevel: s.addLevel,
      removeLevel: s.removeLevel,
      runSawchukZaske: s.runSawchukZaske,
      applyDrawTimeCorrection: s.applyDrawTimeCorrection,
      runBayesian: s.runBayesian,
      setUnitSystem: s.setUnitSystem,
      setEducationalMode: s.setEducationalMode,
      setProtocol: s.setProtocol,
      setPKParams: s.setPKParams,
      setAssayConfig: s.setAssayConfig,
      acknowledgeDisclaimer: s.acknowledgeDisclaimer,
      setCdsNoticeDismissed: s.setCdsNoticeDismissed,
      saveSession: s.saveSession,
      loadSession: s.loadSession,
      refreshSessions: s.refreshSessions,
      logAuditEvent: s.logAuditEvent,
      setContextModifier: s.setContextModifier,
      setConcurrentNephrotoxins: s.setConcurrentNephrotoxins,
      setShowLoadDemo: s.setShowLoadDemo,
      loadDemoDataset: s.loadDemoDataset,
      clearDemoData: s.clearDemoData,
    }),
    shallow,
  );
